import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import AdminIcon from "Assets/svg/icon/admin.svg";
import UserIcon from "Assets/svg/icon/user.svg";
import { ReactSVG } from "react-svg";
import { useTranslation } from 'react-i18next';

function IsGFormatter({ cell }) {
  const { t } = useTranslation();
  return (
    <div className="isGFormatter">
      {cell ? (
        <Tooltip title={t('createdByAdmin')} placement="bottom">
          <ReactSVG src={AdminIcon} className="justIcon adminIcon" />
        </Tooltip>
      ) : (
        <Tooltip title={t('createdByUser')} placement="bottom">
          <ReactSVG src={UserIcon} className="justIcon normalUserIcon" />
        </Tooltip>
      )}
    </div>
  );
}

export default IsGFormatter;
